import { createFileRoute } from "@tanstack/react-router";
import { EntityFormPage } from "@/components/entity-page/EntityFormPage";
import CreateAgentBlueprintForm from "@/components/CreateAgentBlueprintForm";

export const Route = createFileRoute("/dashboard/agent-blueprints/new")({
  component: CreateAgentBlueprintPage,
});

function CreateAgentBlueprintPage() {
  return (
    <EntityFormPage
      title="Create Blueprint"
      description="Add a new reusable agent configuration template."
      backHref="/dashboard/agent-blueprints"
    >
      <CreateAgentBlueprintForm />
    </EntityFormPage>
  );
}
